import React, { useCallback } from 'react';
import 'antd/dist/reset.css';
// import './App.css';
import { Breadcrumb, Layout, Menu, theme, Card, Button, Form, Alert, notification } from 'antd';
import { css } from "@emotion/css";
import WebTag from "./components/WebTag";
import ReactPlayer from 'react-player';
import HeaderMenu from './components/HeaderMenu';
import DefaultLayout from './layouts/DefaultLayout';
function HubspotProd() {
  return (
    <>
      <DefaultLayout
        headerCurrent='hubspotprod'
        tagUrl='https://j.6sc.co/j/068b1b4a-3df0-4c81-a562-e2f74bfee610.js'
        tagSkipProxy
      >
        <Card title="Hubspot Prod Demo">
          <HubspotForm />
        </Card>
        <Card title="Hubspot Legacy Form Demo">
          <HubspotFormLegacy />
        </Card>
      </DefaultLayout>
    </>
  );
}

function HubspotForm() {
  const ref = useCallback((node: HTMLDivElement) => {
    if (!node) return;
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/developer/21983060.js";
    script.defer = true;
    node.appendChild(script);
  }, []);
  return (
    <div
      ref={ref}
      className="hs-form-html"
      data-region="na1"
      data-form-id="53353959-c45d-4e3f-9ce9-9a614f2f7f9d"
      data-portal-id="21983060"
    />
  );
}

function HubspotFormLegacy() {
  const ref = useCallback((node: HTMLDivElement) => {
    if (!node) return;
    const s1 = document.createElement("script");
    s1.charset = "utf-8";
    s1.type = "text/javascript";
    s1.src = "//js.hsforms.net/forms/embed/v2.js";
    node.appendChild(s1);
    s1.onload = function () {
      const s2 = document.createElement("script");
      s2.innerHTML = `hbspt.forms.create({
        portalId: "21983060",
        formId: "8e900d53-3609-4b63-9a98-62daf6d520d2",
        region: "na1"
      });`
      node.appendChild(s2);
    }
  }, []);
  return <div ref={ref} />;
}

export default HubspotProd;
